import React from 'react';
import { IFrameworkPCState, initFrameworkState } from '../../types';

const FrameworkPCContext = React.createContext<{ state: IFrameworkPCState, dispatch: any}>({ 
  state: initFrameworkState,
  dispatch: () => {}
});

FrameworkPCContext.displayName = 'framework-pc-context';

export default FrameworkPCContext